import React from 'react';
import PropTypes from 'prop-types';

export const Tab = ({ children, active, onClick, className = '', ...props }) => {
  const baseClasses = 'px-4 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500';
  const activeClasses = active 
    ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-100' 
    : 'text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white';
  
  return (
    <button
      type="button"
      className={`${baseClasses} ${activeClasses} ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Tab.defaultProps = {
  active: false,
  onClick: () => {},
  className: '',
};

export const Tabs = ({ children, className = '', ...props }) => (
  <div 
    className={`border-b border-gray-200 dark:border-gray-700 flex space-x-4 ${className}`}
    {...props}
  >
    {children}
  </div>
);

Tabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Tabs.defaultProps = {
  className: '',
};

export default Tabs;
